import { ApolloClient, InMemoryCache, gql } from '@apollo/client/core';
import gsap from 'gsap';
import { v4 as uuidv4 } from 'uuid';
import EmblaCarousel from "embla-carousel";
import {getStoreConfig} from "../utils/helpers";

const LAMProductDetail = () => {
  // ----------------------------------------------------------------------- //
  // URL params

  const currentUrl = window.location.href;
  const queryString = currentUrl.split('?')[1];

  const params = new URLSearchParams(queryString);

  const noAnimate = params.get('noanimate');

  let activeKlaviyoNotification = {
    productId: null,
    variantId: null
  };

  // ----------------------------------------------------------------------- //
  // Shopify

  const liquidData = JSON.parse(
    document.getElementById(`lam-product-metafields`).textContent
  );

  const storeConfig = getStoreConfig(liquidData.shopUrl);

  // ----------------------------------------------------------------------- //
  // URL parsing

  const currentURL = new URL(window.location.href);

  const urlData = {
    lid: currentURL.searchParams.get(`lid`),
    sleeve: currentURL.searchParams.get(`sleeve`),
    stand: currentURL.searchParams.get(`stand`),
  };
  
  // ----------------------------------------------------------------------- //
  // DOM

  // carousel

  const overlayCache = {};
  
  const pngOverlayTemplate = document.getElementById(
    `template-product-option-overlay`
  );
  const emblaRoot = document.getElementById(`lam-product-carousel`)
  const bullets = document.querySelectorAll(`.lam-product-carousel__bullet`);
  const firstCarouselSlide = document.querySelector(`.lam-product-carousel__slide[data-index="0"]`);
  const navigateCarouselLeft = document.getElementById(`navigate-carousel-left`);
  const navigateCarouselRight = document.getElementById(`navigate-carousel-right`);

  // navigators
  
  const navigationOverlay = document.getElementById(`navigation-overlay`);
  const overlayTriggers = document.querySelectorAll(`.triggers-overlay`);
  const bottleSwitchers = document.querySelectorAll(`.memobottle-switch`);

  // product add controls

  const addToCartWrapper = document.getElementById(`lam-product-buy`);
  const addToCartForm = document.getElementById(liquidData.cartAddFormId);
  const addToCartFormSticky = document.getElementById(`sticky-add-to-cart`);
  // const addToCartButton = document.getElementById(`add-to-cart-button`);
  const addToCartButtons = document.querySelectorAll(`.product-form-submit`);
  const productVariantId = document.getElementById(`main-product-id`);
  const stickyTouchControls = document.getElementById(`add-to-cart-widget`);
  const toast = document.getElementById(`lam-product-toast`);
  const klaviyoOptionNotifiers = document.querySelectorAll(`.lam-option-notifier`);
  const klaviyoOptionNotifierEmailInline = document.getElementById(`lam-option-notifier-email-inline`);
  const klaviyoOptionNotifierEmailSticky = document.getElementById(`lam-option-notifier-email-sticky`);
  
  const totalPriceLabelInline = document.getElementById(`lam-product-total-price-inline`);
  const totalPriceLabelSticky = document.getElementById(`lam-product-total-price-sticky`);
  
  // options controls
  
  const lidButtonTemplate = document.getElementById(
    `template-product-option-lid`
  );
  const sleeveButtonTemplate = document.getElementById(
    `template-product-option-sleeve`
  );
  const standButtonTemplate = document.getElementById(
    `template-product-option-stand`
  );

  const accessoryWrapper = document.getElementById(`accessory-wrapper`);
  const accessoryLoadingOverlay = document.getElementById(`lam-accessory-loader`);
  const accessoryRows = document.querySelectorAll(`.lam-product-accessories__row`);

  const lidLabel = document.getElementById(`accessory-lid-label`);
  const lidPrice = document.getElementById(`accessory-lid-price`);
  const lidSelector = document.getElementById(`lid-selector`);
  
  const sleeveLabel = document.getElementById(`accessory-sleeve-label`);
  const sleevePrice = document.getElementById(`accessory-sleeve-price`);
  const sleeveSelector = document.getElementById(`sleeve-selector`);
  
  const standLabel = document.getElementById(`accessory-stand-label`);
  const standPrice = document.getElementById(`accessory-stand-price`);
  const standSelector = document.getElementById(`stand-selector`);
 
  // add-on controls

  const addOnWidget = document.getElementById(`addon-widget`);
 
  const addOnQuantity = document.getElementById(`addon-widget-quantity`);
  const addOnQuantityUp = document.getElementById(`addon-quantity-up`);
  const addOnQuantityDown = document.getElementById(`addon-quantity-down`);
  const addOnQuantitySpan = document.getElementById(`addon-quantity-span`);
  const addOnButton = document.getElementById(`addon-widget-to-cart-button`);
  const addOnButtonText = document.getElementById(`addon-widget-button-text`);
  const addOnImageSrc = document.getElementById(`addon-image-src`);
  const addOnToast = document.getElementById(`lam-addon-toast`);
  const addOnTitle = document.getElementById(`addon-product-title`);
  const addOnDescription = document.getElementById(`addon-product-description`);
  const addOnPrice = document.getElementById(`addon-product-price`);
  
  // product expanders

  const expanderButtons = document.querySelectorAll(`.lam-product-expanders__button`);

  let currentAddOnQuantity = 1;

  // ----------------------------------------------------------------------- //
  // variables

  // const addOnProductId = addOnButton.getAttribute(`data-productid`);
  const addOnProductId = storeConfig.addOnProductId;
  
  let addOnVariantId;
  let addOnQuantityNumber = 1;

  let client;
  let embla;

  const addOns = {
    "lid": {
      variantIdvariantId: null,
      labelNode: lidLabel,
      priceNode: lidPrice,
      price: 0,
      title: ``,
    },
    "sleeve": {
      variantId: null,
      labelNode: sleeveLabel,
      priceNode: sleevePrice,
      price: 0,
      title: ``,
    },
    "stand": {
      variantId: null,
      labelNode: standLabel,
      priceNode: standPrice,
      price: 0,
      title: ``,
    },
  };

  // ----------------------------------------------------------------------- //
  // methods: carousel

  const onCarouselChange = () => {
    const activeBullet = bullets[embla.selectedScrollSnap()];
    
    bullets.forEach(bullet => {
      bullet.classList.remove(`active`);
    });
    
    activeBullet.classList.add(`active`);
  }

  // ----------------------------------------------------------------------- //
  // methods: graphql
  
  const preloadImage = async (imageUrl) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      
      img.src = imageUrl;
      img.onload = resolve;
      img.onerror = reject;
    });
  };

  const cacheMediaImage = (mediaImageId, variantId, type) => {
    // type optional
    if (!mediaImageId || !variantId) {
      return;
    }

    const GET_MEDIA_IMAGE_QUERY = gql`
      query GetMediaImage($mediaImageId: ID!) {
        node(id: $mediaImageId) {
          ... on MediaImage {
            id
            image {
              altText
              url
            }
          }
        }
      }
    `;

    client.query({
      query: GET_MEDIA_IMAGE_QUERY,
      variables: {
        mediaImageId,
      },
    })
      .then(result => {
        const mediaImageUrl = result?.data?.node?.image?.url;

        if (mediaImageUrl) {
          if (type) {
            overlayCache[`${variantId}-${type}`] = mediaImageUrl;
          } else {
            overlayCache[variantId] = mediaImageUrl;
          }

          preloadImage(mediaImageUrl);
        }
      })
      .catch(error => {
        console.error('Error fetching media image:', error);
      });
  }

  const fetchLinkedAddOn = () => {
    const GET_PRODUCT_QUERY = gql`
      query GetProductById($productId: ID!) {
        product(id: $productId) {
          id
          title
          handle
          description
          productType
          vendor
          tags
          availableForSale
          onlineStoreUrl
          createdAt
          updatedAt

          featuredImage {
            originalSrc
            transformedSrc(maxWidth: 800, maxHeight: 800, crop: CENTER)
            altText
          }

          shortDescription: metafield(namespace: "lam", key: "_add_on_description") {
            value
          }
  
          variants(first: 1) {
            edges {
              node {
                id
                title
                sku
                priceV2 {
                  amount
                  currencyCode
                }
                compareAtPriceV2 {
                  amount
                  currencyCode
                }
                availableForSale
                selectedOptions {
                  name
                  value
                }
              }
            }
          }
        }
      }
    `;
  
    client.query({
      query: GET_PRODUCT_QUERY,
      variables: {
        productId: `gid://shopify/Product/${addOnProductId}`
      },
    })
    .then(result => {
      const product = result?.data?.product;
      addOnVariantId = product?.variants?.edges?.[0]?.node?.id;
  
      if (!product || !addOnVariantId) {
        console.error(`Linked tablet product not found.`);
      }

      addOnWidget.classList.add(`active`);

      addOnTitle.innerHTML = product.title;
      addOnPrice.innerHTML = `$${parseFloat(product.variants.edges[0].node.priceV2.amount).toFixed(2)}`;
      addOnDescription.innerHTML = product?.shortDescription?.value || product.description;
      addOnImageSrc.setAttribute(`src`, product.featuredImage.transformedSrc);
     
      if (product?.availableForSale) {
        addOnButtonText.innerHTML = `Add to Cart`;
      } else {
        addOnButtonText.innerHTML = `Out of Stock`;
        
        addOnButton.classList.add(`disabled`);
        addOnQuantity.classList.add(`disabled`);
      }
    });
  }  

  const disableOutOfStockSiblings = () => {
    return new Promise((resolve, reject) => {
      const GET_SIBLINGS_QUERY = gql`
        query GetSiblingBottles {
          collection(handle: "all") {
            handle
            products(
              first: 250
            ) {
              edges {
                node {
                  id
                  title
                  handle
                  tags
                  productType
                  availableForSale
                }
              }
            }
          }
        }
      `;

      client.query({
        query: GET_SIBLINGS_QUERY
      })
      .then(result => {
        const products = result?.data?.collection?.products?.edges || [];

        let siblings = [];

        if (products?.[0]) {
          siblings = products.filter(productEdge => {
            const product = productEdge?.node;

            return (
              product?.tags?.includes(`lam-bottle-og`) ||
              product?.tags?.includes(`lam-bottle-ss`)
            ) && !product?.availableForSale;
          });
        }

        if (siblings?.[0]) {
          siblings.forEach(sibling => {
            if (liquidData?.compatibility?.toLowerCase() === `stainless steel memobottle`) {
              const linkToDisable = document.querySelector(`.lam-product-accessory--color[data-bottle="${sibling.node.handle}"]`);

              if (linkToDisable) {
                linkToDisable.classList.add(`disabled`);
              }
            } else {
              const linkToDisable = document.querySelector(`.memobottle-switch[data-bottle="${sibling.node.handle}"]`);
  
              if (linkToDisable) {
                linkToDisable.querySelector(`.lam-product-optiongroup__button`).classList.add(`disabled`);
              }
            }
          });
        }

        resolve(siblings);
      });
    });
  }

  const fetchProductCache = () => {
    return new Promise((resolve, reject) => {
      const GET_PRODUCTS_QUERY = gql`
        query GetProductsByMetafields($compatibleWithValue: String!) {
          collection(handle: "all") {
            handle
            products(
              first: 250,
              filters: [
                {
                  productMetafield: {
                    namespace: "custom",
                    key: "compatible_with",
                    value: $compatibleWithValue
                  }
                }
              ]
            ) {
              edges {
                node {
                  id
                  title
                  handle
                  description
                  productType
                  vendor
                  tags
                  availableForSale
                  onlineStoreUrl
                  createdAt
                  updatedAt

                  bottleSize: metafield(namespace: "custom", key: "bottle_size") {
                    value
                  }
                  compatibleWith: metafield(namespace: "custom", key: "compatible_with") {
                    value
                  }
                  icon: metafield(namespace: "lam", key: "_options_svg_icon") {
                    value
                  }
                  overlayA5: metafield(namespace: "lam", key: "_options_png_overlay_a5") {
                    value
                  }
                  overlayA6: metafield(namespace: "lam", key: "_options_png_overlay_a6") {
                    value
                  }
                  overlayA7: metafield(namespace: "lam", key: "_options_png_overlay_a7") {
                    value
                  }
                  overlaySlim: metafield(namespace: "lam", key: "_options_png_overlay_slim") {
                    value
                  }

                  variants(first: 1) {
                    edges {
                      node {
                        id
                        title
                        sku
                        priceV2 {
                          amount
                          currencyCode
                        }
                        compareAtPriceV2 {
                          amount
                          currencyCode
                        }
                        availableForSale
                        selectedOptions {
                          name
                          value
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      `;

      client.query({
        query: GET_PRODUCTS_QUERY,
        variables: {
          compatibleWithValue: liquidData.compatibility
        },
      })
      .then(result => {
        let products = result?.data?.collection?.products?.edges || [];

        products = products.filter(
          ({node}) =>
            node?.compatibleWith?.value?.toLowerCase()?.includes(liquidData?.compatibility?.toLowerCase())
        );

        resolve(products);
      });
    });
  }

  const resetAddToCartModule = () => {
    klaviyoOptionNotifierEmailInline.classList.add(`hidden`);
    klaviyoOptionNotifierEmailSticky.classList.add(`hidden`);

    if (klaviyoOptionNotifiers?.[0]) {
      klaviyoOptionNotifiers.forEach(notifier => {
        activeKlaviyoNotification = {
          productId: null,
          variantId: null
        };
        notifier.classList.add(`hidden`);
      })
    }

    if (addToCartButtons?.[0]) {
      addToCartButtons.forEach(button => {
        button.classList.remove(`hidden`);
      });
    }
  }

  // ----------------------------------------------------------------------- //
  // methods: stock parsing

  const detectStockedBottles = (products) => {
    if (!products?.[0]) {
      return;
    }

    const bottles = products.filter(productEdge => {
      const product = productEdge?.node;

      return (
        product?.productType === `memobottle™` ||
        product?.title?.toLowerCase()?.includes(`stainless steel`)
      );
    });
  }

  // ----------------------------------------------------------------------- //
  // methods: filtering

  const filterCompatibleLids = (products) => {
    if (!products?.[0]) {
      return;
    }

    const lids = [];

    const filteredLids = products.filter(productEdge => {
      const product = productEdge?.node;

      return product?.productType !== `memobottle™` && 
        product?.title?.includes(` Lid (${liquidData.compatibility})`);
    });

    const lidTitleSuffix = ` Lid (${liquidData.compatibility})`;

    filteredLids.forEach(productEdge => {
      const product = productEdge.node;
      const variantEdge = product?.variants?.edges?.[0];

      if (variantEdge) {
        const variant = variantEdge.node;

        // fire + forget
        cacheMediaImage(product?.overlay?.value, variant.id, null);
        cacheMediaImage(product?.overlayA5?.value, variant.id, `A5`);
        cacheMediaImage(product?.overlayA6?.value, variant.id, `A6`);
        cacheMediaImage(product?.overlayA7?.value, variant.id, `A7`);
        cacheMediaImage(product?.overlaySlim?.value, variant.id, `Slim`);

        lids.push({
          displayTitle: product.title.replace(lidTitleSuffix, ``),
          icon: product?.icon,
          productId: product.id,
          productHandle: product.handle,
          ...variant
        });
      } else {
        // todo: would this ever happen?
        console.warn(`No variant edge found for: `, product);

        lids.push({
          title: product.title,
          price: null,
        });
      }
    });

    return lids;
  }

  const filterCompatibleSleeves = (products) => {
    if (!products?.[0]) {
      return;
    }

    const filteredSleeves = products.filter(productEdge => {
      const product = productEdge?.node;
      const formattedTitle = product?.title?.toLowerCase();

      // console.log(product);

      return !formattedTitle?.includes(`memobottle`) && 
        formattedTitle?.includes(`silicone sleeve`) &&
        product?.bottleSize?.value === liquidData.bottle_size;
    });

    const sleeves = [];

    const sleeveTitlePrefix = `${liquidData.bottle_size} Silicone Sleeve - `;

    filteredSleeves.forEach(productEdge => {
      const product = productEdge.node;
      const variantEdge = product?.variants?.edges?.[0];

      if (variantEdge) {
        const variant = variantEdge.node;

        // fire + forget
        cacheMediaImage(product?.overlay?.value, variant.id, null);
        cacheMediaImage(product?.overlayA5?.value, variant.id, `A5`);
        cacheMediaImage(product?.overlayA6?.value, variant.id, `A6`);
        cacheMediaImage(product?.overlayA7?.value, variant.id, `A7`);
        cacheMediaImage(product?.overlaySlim?.value, variant.id, `Slim`);

        sleeves.push({
          displayTitle: product.title.replace(sleeveTitlePrefix, ``),
          icon: product?.icon,
          overlay: product?.overlay,
          productId: product.id,
          productHandle: product.handle,
          ...variant
        });
      } else {
        // todo: would this ever happen?
        console.warn(`No variant edge found for: `, product);

        sleeves.push({
          title: product.title,
          price: null,
        });
      }
    });

    return sleeves;
  }

  const filterCompatibleStands = (products) => {
    if (!products?.[0]) {
      return;
    }
    
    const stands = [];

    const filteredStands = products.filter(productEdge => {
      const product = productEdge?.node;

      return product?.productType !== `memobottle™` && 
        product?.title?.includes(` Stand (${liquidData.compatibility})`);
    });

    const standTitleSuffix = ` Stand (${liquidData.compatibility})`;

    filteredStands.forEach(productEdge => {
      const product = productEdge.node;
      const variantEdge = product?.variants?.edges?.[0];

      if (variantEdge) {
        const variant = variantEdge.node;

        // fire + forget
        cacheMediaImage(product?.overlay?.value, variant.id, null);
        cacheMediaImage(product?.overlayA5?.value, variant.id, `A5`);
        cacheMediaImage(product?.overlayA6?.value, variant.id, `A6`);
        cacheMediaImage(product?.overlayA7?.value, variant.id, `A7`);
        cacheMediaImage(product?.overlaySlim?.value, variant.id, `Slim`);

        stands.push({
          displayTitle: product.title.replace(standTitleSuffix, ``),
          icon: product?.icon,
          overlay: product?.overlay,
          productId: product.id,
          productHandle: product.handle,
          ...variant
        });
      } else {
        // todo: would this ever happen?
        console.warn(`No variant edge found for: `, product);

        stands.push({
          title: product.title,
          price: null,
        });
      }
    });

    return stands;
  }

  // ----------------------------------------------------------------------- //
  // methods: append to document

  const appendTemplateNode = (type, clone, parent, data) => {
    const button = clone.querySelector(`.lam-product-accessory`);
    const iconContainer = button.querySelector(`.lam-product-accessory__icon`);

    button.setAttribute(`data-variantid`, data.id);
    button.setAttribute(`data-price`, data.priceV2.amount);
    button.setAttribute(`data-title`, data.displayTitle);
    button.setAttribute(`data-type`, type);

    button.classList.add(`url-selectable`);

    if (iconContainer && data?.icon?.value) {
      iconContainer.innerHTML = data.icon.value;
    }

    if (!data?.availableForSale) {
      button.parentNode.classList.add(`unavailable`);

      const productId = data.productId.replace(`gid://shopify/Product/`, ``);
      const variantId = data.id.replace(`gid://shopify/ProductVariant/`, ``);

      button.parentNode.addEventListener(`click`, event => {
        klaviyoOptionNotifierEmailInline.classList.remove(`hidden`);
        klaviyoOptionNotifierEmailSticky.classList.remove(`hidden`);

        activeKlaviyoNotification = {
          productId,
          variantId
        };

        if (klaviyoOptionNotifiers?.[0]) {
          klaviyoOptionNotifiers.forEach(notifier => {
            notifier.classList.remove(`hidden`);
          })

          addToCartButtons.forEach(button => {
            button.classList.add(`hidden`);
          });
        }
      });
    } else {
      button.parentNode.addEventListener(`click`, event => {
        resetAddToCartModule();
      });
    }

    parent.appendChild(clone);
  }

  const compareByAvailability = (productA, productB) => {
    if (productA.availableForSale && !productB.availableForSale) {
      return -1;
    }
    if (!productA.availableForSale && productB.availableForSale) {
      return 1;
    }
    return 0;
  };

  const appendTemplateNodes = (products) => {
    if (!products) {
      return;
    }

    if (products?.lids?.[0]) {
      products.lids.sort(compareByAvailability).forEach(lid => {
        const lidButtonClone = lidButtonTemplate.content.cloneNode(true);
        appendTemplateNode(`lid`, lidButtonClone, lidSelector, lid);
      });
    } else if (lidSelector) {
      lidSelector.parentNode.remove();
    }

    if (products?.sleeves?.[0]) {
      products.sleeves.sort(compareByAvailability).forEach(sleeve => {
        const sleeveButtonClone = sleeveButtonTemplate.content.cloneNode(true);
        appendTemplateNode(`sleeve`, sleeveButtonClone, sleeveSelector, sleeve);
      });
    } else if (sleeveSelector) {
      sleeveSelector.parentNode.remove();
    }

    if (products?.stands?.[0]) {
      products.stands.sort(compareByAvailability).forEach(stand => {
        const standButtonClone = standButtonTemplate.content.cloneNode(true);
        appendTemplateNode(`stand`, standButtonClone, standSelector, stand);
      });
    } else if (standSelector) {
      standSelector.parentNode.remove();
    }
  }

  const animateDetails = () => {
    if (noAnimate === `true`) {
      gsap.to(accessoryLoadingOverlay, {
        opacity: 0,
        duration: 0
      });
  
      gsap.to(accessoryWrapper, {
        height: `auto`,
        duration: 0
      });
      
      accessoryRows.forEach((row, index) => {
        gsap.to(row, {
          opacity: 1,
          y: 0,
          duration: 0,
        });
      });

      return;
    }

    gsap.to(accessoryLoadingOverlay, {
      opacity: 0,
      duration: 0.3,
      ease: `power2.inOut`
    });

    gsap.to(accessoryWrapper, {
      height: `auto`,
      duration: 0.75,
      ease: `power2.inOut`,
    });
    
    accessoryRows.forEach((row, index) => {
      const delay = index * 0.075;

      gsap.to(row, {
        opacity: 1,
        y: 0,
        duration: 0.9,
        delay,
        ease: `power3.inOut`,
      });
    });
  }

  // ----------------------------------------------------------------------- //
  // methods: click listeners

  const addTriggerListeners = () => {
    overlayTriggers.forEach(trigger => {
      trigger.addEventListener(`click`, event => {
        navigationOverlay.classList.add(`active`);
      });
    });
  }

  const addScrollListeners = () => {
    if (typeof window === `undefined`) {
      return;
    }

    window.addEventListener(`scroll`, () => {
      if (addToCartWrapper.getBoundingClientRect().top < window.innerHeight) {
        stickyTouchControls.classList.remove(`active`);
      } else {
        stickyTouchControls.classList.add(`active`);
      }
    });
  }

  const updateDisplayPrice = () => {
    if (!totalPriceLabelInline || !totalPriceLabelSticky) {
      return;
    }

    let addOnTotal = 0;

    Object.keys(addOns).forEach(key => {
      const addOn = addOns[key];

      addOnTotal += parseFloat(addOn.price);
    });

    const totalPrice = parseFloat(parseFloat(liquidData.default_price) + parseFloat(addOnTotal)).toFixed(2)

    totalPriceLabelInline.innerHTML = `$${totalPrice} ${liquidData.currency}`;
    totalPriceLabelSticky.innerHTML = `$${totalPrice} ${liquidData.currency}`;
  }

  const onButtonClick = (type, event, button, siblings) => {
    siblings.forEach(sibling => {
      sibling.classList.remove(`active`);
    });

    button.classList.add(`active`);
    
    const variantId = event.target.getAttribute(`data-variantid`);
    const price = event.target.getAttribute(`data-price`);
    const title = event.target.getAttribute(`data-title`);

    const unselected = variantId === `none`;

    if (unselected) {
      addOns[type].title = ``;
      addOns[type].variantId = null;
      addOns[type].labelNode.innerHTML = `None`;
      addOns[type].priceNode.innerHTML = `$0.00`;
      addOns[type].price = 0;

      resetAddToCartModule();
    } else {
      addOns[type].title = title;
      addOns[type].variantId = variantId;
      addOns[type].labelNode.innerHTML = title;
      addOns[type].priceNode.innerHTML = `$${parseFloat(price).toFixed(2)}`;
      addOns[type].price = price;
    }

    updateDisplayPrice();

    bottleSwitchers.forEach(bottleSwitcher => {
      const href = new URL(bottleSwitcher.getAttribute('href'));
    
      href.searchParams.set(type, addOns[type]?.title ? addOns[type]?.title : `none`);
    
      bottleSwitcher.setAttribute(`href`, href.toString());
    });

    //
    // carousel image manipulation

    if (embla) {
      embla.scrollTo(0);
    }

    const overlaysForType = document.querySelectorAll(`.lam-product-carousel__slide__overlay[data-type="${type}"]`);
    const appendedOverlay = document.querySelector(`.lam-product-carousel__slide__overlay[data-variantid="${variantId}"]`);

    if (overlaysForType?.[0]) {
      overlaysForType.forEach((overlay) => {
        overlay.classList.remove(`active`);
      });
    }

    if (appendedOverlay) {
      //
      // we already appended this one, it's just hidden
      appendedOverlay.classList.add(`active`);
      return;
    }

    const overlayUrl = overlayCache?.[`${variantId}-${liquidData.bottle_size}`];

    if (unselected || !overlayUrl) {
      return;
    }

    //
    // we must append a new overlay

    const overlayClone = pngOverlayTemplate.content.cloneNode(true);
    const figure = overlayClone.querySelector(`.lam-product-carousel__slide__overlay`);

    figure.setAttribute(`data-type`, type);
    figure.setAttribute(`data-variantid`, variantId);

    const elem = document.createElement(`img`);
    elem.setAttribute(`src`, overlayUrl);

    figure.appendChild(elem);
    
    firstCarouselSlide.appendChild(overlayClone);

    setTimeout(() => {
      figure.classList.add(`active`);
    }, 100);
  }
  
  const addOptionListeners = () => {
    const lidButtons = document.querySelectorAll(`.lam-product-accessory--lid`);
    const sleeveButtons = document.querySelectorAll(`.lam-product-accessory--sleeve`);
    const standButtons = document.querySelectorAll(`.lam-product-accessory--stand`);
    
    if (lidButtons?.[0]) {
      lidButtons.forEach(lidButton => {
        lidButton.addEventListener(`click`, (event) => {
          onButtonClick(`lid`, event, lidButton, lidButtons);
        });
      });
    }

    if (sleeveButtons?.[0]) {
      sleeveButtons.forEach(sleeveButton => {
        sleeveButton.addEventListener(`click`, (event) => {
          onButtonClick(`sleeve`, event, sleeveButton, sleeveButtons);
        });
      });
    }
    
    if (standButtons?.[0]) {
      standButtons.forEach(standButton => {
        standButton.addEventListener(`click`, (event) => {
          onButtonClick(`stand`, event, standButton, standButtons);
        });
      });
    }
  }

  const clickSelectedOptions = () => {
    Object.keys(urlData).forEach(key => {
      if (!urlData[key]) {
        return;
      }

      const value = urlData[key];

      const clickableButton = document.querySelector(`.url-selectable[data-type="${key}"][data-title="${value}"]`);

      if (clickableButton) {
        setTimeout(() => {
          clickableButton.click();
        }, 500);
      }
    });

    setTimeout(() => {
      lidLabel.classList.remove(`hidden`);
      sleeveLabel.classList.remove(`hidden`);
      standLabel.classList.remove(`hidden`);
    }, 600);
  }

  // ----------------------------------------------------------------------- //
  // cart controls

  const addCarouselListeners = () => {
    if (!embla) {
      return;
    }

    if (navigateCarouselLeft) {
      navigateCarouselLeft.addEventListener(`click`, event => {
        embla.scrollPrev();
      });
    }

    if (navigateCarouselRight) {
      navigateCarouselRight.addEventListener(`click`, event => {
        embla.scrollNext();
      });
    }
  }

  const addCartListeners = () => {
    if (!addToCartForm) {
      return;
    }

    [addToCartForm, addToCartFormSticky].forEach(form => {
      form.addEventListener(`submit`, async e => {
        e.preventDefault();
  
        addToCartButtons.forEach(button => {
          button.classList.add(`disabled`);
          button.setAttribute(`aria-disabled`, true);
        });
  
        const coreVariantId = parseInt(productVariantId.value);
        const uuid = uuidv4();
  
        const cartItems = [
          {
            id: coreVariantId,
            quantity: 1,
            properties: {
              __uuid: uuid,
              __addons: [],
              __material: liquidData.compatibility,
            }
          }
        ];
  
        Object.keys(addOns).forEach(key => {
          const addOn = addOns[key];
          
          if (addOn?.variantId) {
            const formattedAddOnVariantId = parseInt(addOn.variantId.replace(`gid://shopify/ProductVariant/`, ``));
  
            cartItems[0].properties.__addons.push(formattedAddOnVariantId);

            cartItems.push(
              {
                id: formattedAddOnVariantId,
                quantity: 1,
                properties: {
                  __uuid: uuid,
                  __sourceVariant: coreVariantId,
                  __overlayImage: overlayCache?.[`${addOn.variantId}-${liquidData.bottle_size}`]
                }
              }
            );
          }
        });
  
        const requestBody = {
          items: cartItems,
          sections: `lam-cart-drawer`
        };
  
        const cartDrawerContainer = document.getElementById(`lam-cart-drawer`);
  
        if (cartDrawerContainer) {
          cartDrawerContainer.remove();
        }
  
        try {
          const response = await fetch(`${routes.cart_add_url}`, {
            method: `POST`,
            headers: {
              "Content-Type": `application/json`,
              "Accept": `application/javascript`
            },
            body: JSON.stringify(requestBody)
          });
  
          if (response.status !== 200) {
            console.error(responseData.description);
          }
  
          const responseData = await response.json();
          
          // ---------------------------------------------------------------------
          // generate cart drawer HTML
          
          // elements
          const container = document.createElement(`div`);
          container.innerHTML = responseData.sections[`lam-cart-drawer`];
  
          const drawer = container?.firstChild?.firstChild;
          
          if (!drawer) {
            return;
          }
  
          // remove unrelated rows
          const justAdded = responseData?.items?.filter(({ properties }) => properties?.__uuid === uuid);
  
          drawer.querySelectorAll(`.cart-summary-overlay__row-body`).forEach(row => {
            const rowUuid = row.getAttribute(`data-uuid`);
  
            if (rowUuid !== uuid) {
              row.remove();
            }
          });
  
          // figure out what we just added
          const justAddedSource = justAdded?.find(({ properties }) => {
            return typeof properties?.__addons !== `undefined`;
          });
          const justAddedAddOns = justAdded?.filter(({ properties }) => {
            return typeof properties?.__sourceVariant !== `undefined`;
          });
  
          let lineItemPrice = justAddedSource?.line_price;
              
          const addOnText = {
            lid: {
              addOn: null,
              label: `Extra Lid`,
              title: `None`
            },
            sleeve: {
              addOn: null,
              label: `Silicone Sleeve`,
              title: `None`
            },
            stand: {
              addOn: null,
              label: `Desk Stand`,
              title: `None`
            }
          };
  
          // if we have addOns, we have adjustments...
          if (justAddedAddOns?.[0]) {
            const imageNode = drawer.querySelector(`.cart-summary-overlay__image-layer`);
            const metadataContainer = drawer.querySelector(`.cart-summary-overlay__variant`);
            const priceListDesktop = drawer.querySelector(`.cart-summary-overlay__price-aggregator`);
            const priceContainers = drawer.querySelectorAll(`.cart-summary-overlay__dynamic-price`);
  
            if (priceListDesktop) {
              const priceItem = document.createElement(`h4`);
    
              // priceItem.classList.add(`cart-item__price__separator`);
              priceItem.classList.add(`lam-caption`);
              priceItem.innerText = `-`;
    
              priceListDesktop.appendChild(priceItem);
            }
            
            justAddedAddOns.forEach(addOn => {
              lineItemPrice += addOn.price;
  
              //
              // image merge
  
              if (addOn?.properties?.__overlayImage) {
                const overlay = document.createElement(`div`);
                overlay.classList.add(`cart-item__image__overlay`);
                
                const image = document.createElement(`img`);
                image.setAttribute(`src`, addOn.properties.__overlayImage);
                
                overlay.appendChild(image);
                
                imageNode.appendChild(overlay);
              }
  
              //
              // text parsing
  
              const parsedProductType = addOn?.title?.toLowerCase();
    
              if (parsedProductType?.includes(` lid (`)) {
                addOnText.lid.addOn = addOn;
                addOnText.lid.title = addOn.title
                  .replace(` (Original memobottle)`, ``)
                  .replace(` (Stainless Steel memobottle`, ``)
                  .replace(` Lid`, ``);
    
              } else if (parsedProductType?.includes(`silicone sleeve`)) {
                addOnText.sleeve.addOn = addOn;
                addOnText.sleeve.title = addOn.title
                  .replace(` (Original memobottle)`, ``)
                  .replace(` (Stainless Steel memobottle`, ``)
                  .replace(` Silicone Sleeve`, ``)
                  .replace(` Silicone sleeve`, ``)
                  .replace(`A5 - `, ``)
                  .replace(`A6 - `, ``)
                  .replace(`A7 - `, ``)
                  .replace(`Slim - `, ``)
                  .replace(`SLIM - `, ``);
    
              } else if (parsedProductType?.includes(` stand (`)) {
                addOnText.stand.addOn = addOn;
                addOnText.stand.title = addOn.title
                  .replace(` (Original memobottle)`, ``)
                  .replace(` (Stainless Steel memobottle`, ``)
                  .replace(` Desk Stand`, ``)
                  .replace(` Desk stand`, ``);
              }
            });
  
            // endforeach
            let attributeText = `
              <h4 class="lam-caption">Material: ${justAddedSource.properties.__material}</h4>
            `;
  
            Object.keys(addOnText).forEach(key => {
              const addOn = addOnText[key];
  
              attributeText += `
                <h4 class="lam-caption">${addOn.label}: ${addOn.title}</h4>
              `;
  
              if (priceListDesktop) {
                const priceItem = document.createElement(`div`);
  
                priceItem.classList.add(`lam-caption`);
                priceItem.innerText = addOn?.addOn?.price ? `$${parseFloat(addOn.addOn.price / 100).toFixed(2)}` : `-`;
  
                priceListDesktop.appendChild(priceItem);
              }
            });
  
            metadataContainer.innerHTML = attributeText;
  
            const summaryDisplayPrice = `$${parseFloat(lineItemPrice / 100).toFixed(2)} ${liquidData.currency}`;
  
            priceContainers.forEach(container => {
              container.innerHTML = summaryDisplayPrice;
            });
          }
  
          // prepend completed drawer to document
          document.body.prepend(drawer);
        } catch (error) {
          console.error(error);
        } finally {
          toast.classList.add(`active`);
  
          document.documentElement.dispatchEvent(
            new CustomEvent(`theme:cartchanged`, { bubbles: true, cancelable: false })
          );
  
          const cartDrawerContainer = document.getElementById(`lam-cart-drawer`);
  
          addCartDrawerListeners(cartDrawerContainer);
  
          setTimeout(() => {
            cartDrawerContainer.classList.add(`active`);
          }, 100);
  
          setTimeout(() => {
            toast.classList.remove(`active`);

            addToCartButtons.forEach(button => {
              button.classList.remove(`disabled`);
              button.setAttribute(`aria-disabled`, false);
            });
          }, 3000);
        }
      });
    });
  }

  const updateAddonQuantity = () => {
    if (!addOnQuantitySpan) {
      return;
    }

    currentAddOnQuantity = addOnQuantityNumber;

    addOnQuantitySpan.innerHTML = addOnQuantityNumber;
  }

  const addWidgetListeners = () => {
    if (addOnQuantityUp) {
      addOnQuantityUp.addEventListener(`click`, (event) => {
        addOnQuantityNumber += 1;
        
        updateAddonQuantity();
      });

    }
    
    if (addOnQuantityDown) {
      addOnQuantityDown.addEventListener(`click`, (event) => {
        if (addOnQuantityNumber === 1) {
          return;
        }

        addOnQuantityNumber -= 1;
        
        updateAddonQuantity();
      });
    }

    if (addOnButton && addOnVariantId) {
      addOnButton.addEventListener(`click`, async e => {
        e.preventDefault();

        addOnButton.classList.add(`disabled`);
        addOnButton.setAttribute(`aria-disabled`, true);

        const requestBody = {
          items: [
            {
              id: addOnVariantId.replace(`gid://shopify/ProductVariant/`, ``),
              quantity: currentAddOnQuantity,
            }
          ]
        };

        try {
          const response = await fetch(`${routes.cart_add_url}`, {
            method: `POST`,
            headers: {
              "Content-Type": `application/json`,
              "Accept": `application/javascript`
            },
            body: JSON.stringify(requestBody)
          });
  
          const responseData = await response.json();

          document.documentElement.dispatchEvent(
            new CustomEvent(`theme:cartchanged`, { bubbles: true, cancelable: false })
          );
  
          if (response.status !== 200) {
            console.error(responseData.description);
          }
        } catch (error) {
          console.error(error);
        } finally {
          addOnToast.classList.add(`active`);
          
          setTimeout(() => {
            addOnToast.classList.remove(`active`);
            addOnButton.classList.remove(`disabled`);
            addOnButton.setAttribute(`aria-disabled`, false);
          }, 3000);
        }
      });
    }
  }

  const addExpanderListeners = () => {
    if (!expanderButtons?.[0]) {
      return;
    }

    expanderButtons.forEach(expander => {
      expander.addEventListener(`click`, event => {
        const isActive = event.currentTarget.classList.contains(`active`);
        const content = event.currentTarget.parentNode.querySelector(`.lam-product-expanders__content`);
        const icon = event.currentTarget.querySelector(`.lam-product-expanders__icon`);

        event.currentTarget.classList.toggle(`active`);
        
        if (!isActive) {
          gsap.to(icon, {
            transform: `scaleY(-1)`,
            duration: 0.2,
            ease: `power2.inOut`
          });
          gsap.to(content, {
            height: `auto`,
            duration: 0.4,
            ease: `power2.inOut`
          });
        } else {
          gsap.to(icon, {
            transform: `scaleY(1)`,
            duration: 0.2,
            ease: `power2.inOut`
          });
          gsap.to(content, {
            height: 0,
            duration: 0.4,
            ease: `power2.inOut`
          });
        }
      });
    });
  }

  const klaviyoBIS = async (productId, variantId, email) => {
    if (!storeConfig?.klaviyo) {
      return;
    }

    let response;

    try {
      response = await fetch(`https://a.klaviyo.com/onsite/components/back-in-stock/subscribe`, {
        method: `POST`,
        headers: {
          "accept": "application/json, text/plain, */*",
          "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        "body": new URLSearchParams({
          "a": storeConfig.klaviyo,
          "email": email,
          "variant": variantId,
          "product": productId,
          "platform": `shopify`,
        })
      });

      if (response.status !== 200) {
        console.error(response?.description || `Unknown error`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      console.log(`Complete`);
    }

    return response;
  }

  const addKlaviyoListeners = () => {
    if (!klaviyoOptionNotifiers?.[0]) {
      return;
    }

    klaviyoOptionNotifiers.forEach(notifier => {
      notifier.addEventListener(`click`, async e => {
        const mode = e.currentTarget.getAttribute(`data-mode`);
        const email = mode === `inline` ? klaviyoOptionNotifierEmailInline.value : klaviyoOptionNotifierEmailSticky.value;
        const statusTextInline = document.getElementById(`lam-option-notifier-status-inline`);
        const statusTextSticky = document.getElementById(`lam-option-notifier-status-sticky`);

        if (!email || email === ``) {
          statusTextInline.innerText = `Email is required`;
          statusTextSticky.innerText = `Email is required`;
          return;
        }
        
        notifier.classList.add(`disabled`);

        statusTextInline.innerText = `Submitted`;
        statusTextSticky.innerText = `Submitted`;

        const response = await klaviyoBIS(activeKlaviyoNotification.productId, activeKlaviyoNotification.variantId, email);
      });
    })
  }

  // ----------------------------------------------------------------------- //
  // methods: cart drawer

  const addCartDrawerListeners = element => {
    const closeButton = document.getElementById(`lam-cart-drawer-close`);

    if (closeButton) {
      closeButton.addEventListener(`click`, event => {
        element.classList.remove(`active`);
      });
    }
  }

  // ----------------------------------------------------------------------- //
  // executor

  const removePluginElements = () => {
    const elementsToRemove = document.querySelectorAll('.bold_options, .bold_clone');

    elementsToRemove.forEach(element => {
      element.remove();
    });
  }

  const main = async () => {
    client = new ApolloClient({
      uri: `${liquidData.shopUrl}/api/2023-07/graphql.json`,
      cache: new InMemoryCache(),
      headers: {
        "X-Shopify-Storefront-Access-Token": storeConfig.storefront,
      },
    });

    fetchLinkedAddOn(); // async
    animateDetails();

    const products = await fetchProductCache();

    disableOutOfStockSiblings(); // async
    
    detectStockedBottles(products);
    
    const lids = filterCompatibleLids(products);
    const sleeves = filterCompatibleSleeves(products);
    const stands = filterCompatibleStands(products);

    appendTemplateNodes({ lids, sleeves, stands });

    removePluginElements();

    addTriggerListeners();

    addScrollListeners();

    addOptionListeners();
    clickSelectedOptions();
    
    addCartListeners();
    
    addWidgetListeners();

    addExpanderListeners();

    addKlaviyoListeners();

    setTimeout(() => {
      // embla = EmblaCarousel(emblaRoot, {
      //   loop: true
      // }, [Autoplay({
      //   delay: 4000,
      //   rootNode: (emblaRoot) => emblaRoot.parentElement,
      // })]);

      embla = EmblaCarousel(emblaRoot, {
        loop: true
      });
      
      addCarouselListeners();

      embla.on("select", onCarouselChange);
    }, 1000);
  }

  main();
};

export default LAMProductDetail;
